module.exports = __webpack_public_path__ + "media/images/front/common/icon_know-415b0bceb3d79b7dafe7a5187ae3ea95.svg";